// extracted by mini-css-extract-plugin
export var loading = "style-module--loading--d20b7";
export var spin = "style-module--spin--6fa98";